import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import FloatingInput from "../../Components/Common/FloatingForm";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { getUser } from "../../Redux/Actions/Authentication";
import { urls } from "../../Utils/url";
import { useHistory } from "react-router-dom";

export const updateProfile = (
  firstname,
  lastname,
  email,
  token,
  getUser,
  setLoading
) => {
  setLoading(true);
  ApiCall(
    "put",
    `${urls.User}?first_name=${firstname}&last_name=${lastname}&email=${email}`,
    null,
    "EditProfile",
    token,
    function (e) {
      setLoading(false);
      toast.success("مشخصات کاربری به روزرسانی شد", {
        position: "bottom-center",
        autoClose: 5000,
      });
      getUser(e.data);
    },
    () => setLoading(false)
  );
};

const Profile = ({ ...props }) => {
  const { userData, getUser, token, isLogin } = props;
  const [name, setName] = useState(isLogin && userData.first_name);
  const [family, setFamily] = useState(isLogin && userData.last_name);
  const [mobile, setMobile] = useState(isLogin && userData.mobile_number);
  const [email, setEmail] = useState(isLogin && userData.email);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"مشخصات کاربری"} />
        <div
          style={{
            width: "100%",
            height: window.innerHeight * 0.75,
            padding: window.innerWidth * 0.05,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <FloatingInput
            value={name}
            setValue={setName}
            labelShort={"نام"}
            label={"نام"}
          />

          <FloatingInput
            value={family}
            setValue={setFamily}
            labelShort={"نام خانوادگی"}
            label={"نام خانوادگی"}
          />
          <FloatingInput
            value={email}
            setValue={setEmail}
            labelShort={"ایمیل"}
            label={"ایمیل"}
          />
          <FloatingInput
            value={mobile}
            setValue={setMobile}
            labelShort={"تلفن همراه"}
            label={"تلفن همراه"}
            disabled
          />
          <div
            className="BlueButton"
            onClick={() =>
              updateProfile(name, family, email, token, getUser, setLoading)
            }
          >
            {loading ? (
              <BeatLoader size={5} color={"white"} loading={true} />
            ) : (
              <span>دخیر تغییرات</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.auth.userInfo,
    isLogin: state.auth.isLogin,
    token: state.auth.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getUser: (userInfo) => dispatch(getUser(userInfo)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
